import React from 'react';
import './SyllabusErrors.css';

export const SyllabusErrors = ({itemErrors, contentErrors, contentOrphans}) => (
	<ul className="SyllabusErrors">
		{itemErrors.length ? itemErrors.map(error => <li key={error.code}>
			<input type="checkbox"/>
			<span>Syllabus code</span>
			<span className="value">{error.code}</span>
			<span>appears multiple times: rows</span>
			{error.lines.length > 5
				? (
					<span>
						<span className={"value"}>many</span>
						(total count; {error.lines.length})
					</span>
				)
				: (error.lines.map((line, index) => (
					<span key={`${line}_${index}`}>
						<span className="value">{line}</span>
						{index === error.lines.length - 1 ? null : 'and'}
					</span>
				)))
			}
		</li>) : null}
		{contentErrors.length ? contentErrors.map(error => <li>
			<input type="checkbox"/>
			<span>Syllabus content code</span>
			<span className="value">{error.code}</span>
			<span>appears multiple times: rows</span>
			{error.lines.length > 5
				? (
					<span>
						<span className={"value"}>many</span>
						(total count; {error.lines.length})
					</span>
				)
				: (error.lines.map((line, index) => (
					<span key={`${line}_${index}`}>
						<span className="value">{line}</span>
						{index === error.lines.length - 1 ? null : 'and'}
					</span>
				)))
			}
		</li>) : null}
		{contentOrphans.length ? contentOrphans.map(error => <li>
			<input type="checkbox"/>
			<span>Syllabus content code</span>
			<span className="value">{error.code}</span>
			<span>does not have a valid parent item: rows</span>
			{error.lines.length > 5
				? (
					<span>
						<span className={"value"}>many</span>
						(total count; {error.lines.length})
					</span>
				)
				: (error.lines.map((line, index) => (
					<span>
						<span className="value">{line}</span>
						{index === error.lines.length - 1 ? null : 'and'}
					</span>
				)))
			}
		</li>) : null}
	</ul>
);

export default SyllabusErrors;


// WEBPACK FOOTER //
// ./src/syllabus/SyllabusErrors.js